export default "__VITE_ASSET__aKWVgts3__"